const services = [
    {
        icon: "corporate_fare",
        title: "Corporate Transportation",
        description:
            "Reliable and professional transportation solutions for business meetings, conferences, executive travel, and employee shuttles.",
    },
    {
        icon: "airplane_ticket",
        title: "Airport Transfers",
        description:
            "Enjoy timely pickups and drop-offs with comfortable vehicles and experienced drivers, ensuring a stress-free airport journey.",
    },
    {
        icon: "groups",
        title: "Group & Event Charters",
        description:
            "Convenient transportation for weddings, sporting events, concerts, school trips, and large group gatherings of any size.",
    },
    {
        icon: "travel_luggage_and_bags",
        title: "Private Charter Services",
        description:
            "Customized transportation tailored to your schedule, destination, and travel preferences for a seamless private travel experience.",
    },
];
export const Services = () => {

    return (
        <section className="bg-[#F9FAFB] py-16 md:py-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Header */}
                <div className="text-center">
                    <h2 className="text-4xl md:text-5xl font-semibold text-black">
                        Services Tailored to Every Journey
                    </h2>

                    <p className="mt-6 max-w-3xl mx-auto text-gray-500 text-base md:text-lg leading-relaxed">
                        Whether you're planning a corporate event, airport transfer,
                        group excursion, or private charter, we provide dependable
                        transportation solutions customized to your needs.
                    </p>
                </div>

                {/* Cards */}
                <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className="xl:w-[250px] bg-white border border-[#D0D0D0] rounded-[17px] px-[14px] py-[16px] text-center flex flex-col gap-[6px]"
                        >
                            <span className="material-symbols-outlined text-[35px] text-secondryBlue">
                                {service.icon}
                            </span>

                            <h3 className="mt-6 text-[16px] md:text-[17px]  font-medium text-secondryBlue">
                                {service.title}
                            </h3>

                            <p className="mt-5 text-gray-500 text-[13px]">
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}